module.exports = __webpack_public_path__ + "static/img/Thomas-Sims.6e1a4b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Thomas-Sims.jpg
// module id = NE5X
// module chunks = 0